<template>
  <div class="wh100">
    <div
      style="
        height: 40px;
        display: flex;
        font-size: 18px;
        font-weight: bold;
        align-items: center;
        padding-left: 10px;
      "
    >
      <div style="margin-right: 10px">
        <el-button type="primary" @click="$router.go(-1)"
          ><i class="el-icon-back" style="margin-right: 10px"></i> 后退前页</el-button
        >
      </div>
      <div style="color: #000">
        <span
          style="cursor: pointer"
          @click="$router.push('/ProjectInfo/ProjectAll?id=' + $route.query.id)"
          >{{ backName || "工作台" }}</span
        >
        <i class="el-icon-arrow-right"></i>
      </div>
      <div style="color: #606266" class="ellipsis">项目设备分类</div>
    </div>
    <div
      style="height: calc(100vh - 130px); overflow-y: auto; margin-top: 10px"
      v-loading="Loading"
    >
      <!-- <el-card shadow="never" style="width: 45%"></el-card>
      <div style="width: 10%"></div> -->
      <el-card style="width: 45%; margin: 0 auto" shadow="never">
        <div slot="header" style="display: flex; justify-content: space-between">
          <span>请设置当前项目需要的设备分类</span>
          <el-button type="primary" @click="subProjectClass">保存</el-button>
        </div>
        <el-tree
          :data="TreeData"
          show-checkbox
          node-key="id"
  
          :props="defaultProps"
          ref="dialogTree"
          @check-change="handleCheckChange"
          class="tre"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span
              v-if="data.children && data.children.length > 0"
              style="font-weight: 1000; font-size: 16px"
            >
              <i class="el-icon-s-grid" style="font-size: 18px"></i>&nbsp;{{
                node.label
              }}</span
            >
            <span v-if="!data.children"
              ><i class="el-icon-receiving"></i> {{ node.label }}</span
            >
            <!-- <span> {{ data }}</span> -->
          </span>
        </el-tree>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "title",
      },
      ProjectId: "",
      backName: "",
      EquipmentClassificationIds: [],
      ProjectEquipmentClassificationIds: [],
      Loading: false,
      TreeData: [],
    };
  },
  props: {},
  components: {},
  methods: {
    subProjectClass() {
      this.Loading = true;
      this.$http
        .post("/Base_ProjectWork/Base_Project/SaveProjectDeviceTypeData", {
          ProjectId: this.ProjectId,
          EquipmentClassificationIds: this.EquipmentClassificationIds,
        })
        .then((res) => {
          this.Loading = false;
          if (res.Success) {
            this.$notify.success("保存成功");
            this.dialogVisible = false;
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getProjectTreeData() {
      this.EquipmentClassificationIds = [];
      this.Loading = true;
      await this.$http
        .post(
          "/Base_ProjectWork/Base_Project/GetProjectDevice?ProjectId=" + this.ProjectId
        )
        .then((resJson) => {
          this.Loading = false;
          if (resJson.Success) {
            this.ProjectEquipmentClassificationIds = [
              ...resJson.Data.EquipmentClassificationIds,
            ];
            this.EquipmentClassificationIds = JSON.parse(
              JSON.stringify(this.ProjectEquipmentClassificationIds)
            );
            let Data = JSON.parse(JSON.stringify(this.ProjectEquipmentClassificationIds));
            this.$nextTick(() => {
              console.log(Data, "33333333");
              if (Data.length > 0) {
                if (this.$refs.dialogTree && this.$refs.dialogTree.setCheckedKeys) {
                  this.$refs.dialogTree.setCheckedKeys(Data);
                }
              } else {
                if (
                  this.$refs.dialogTree &&
                  this.$refs.dialogTree.setCheckedKeys &&
                  this.$refs.dialogTree.getCheckedNodes
                ) {
                  this.$refs.dialogTree.setCheckedKeys(
                    this.$refs.dialogTree.getCheckedNodes(),
                    false
                  );
                }
              }
            });
          }
        });
    },
    async getTreeData() {
      this.Loading = true;
      await this.$http
        .post(
          "/Base_ProjectManage/Project_DictionaryMain/GetDictionaryTreeByDicKey?DicKey=EquipmentClassification"
        )
        .then((resJson) => {
          if (resJson.Success) {
            this.Loading = false;
            this.TreeData = resJson.Data[0].children;
          }
        });
    },
    handleCheckChange() {
      this.EquipmentClassificationIds =
        this.$refs.dialogTree && this.$refs.dialogTree.getCheckedKeys
          ? this.$refs.dialogTree.getCheckedKeys()
          : [];
      console.log(this.EquipmentClassificationIds, "22222222");
    },
  },
  mounted() {},
  async created() {
    this.ProjectId = this.$route.query.id;
    this.backName = window.localStorage.getItem("ProjectName") || "";
    // ;
    await this.getTreeData();
    this.getProjectTreeData();
  },
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
::v-deep .tre {
  width: 50%;
  margin: 0 auto;
}
</style>
